export default "__VITE_ASSET__3bc96147__"